const Time = {
  delta_time: 0,
  elapsed_time: 0,
  _last: 0,

  update() {
    const now = performance.now() / 1000;
    this.delta_time = this._last ? now - this._last : 0.016;
    this._last = now;
    this.elapsed_time += this.delta_time;
  },
};

export { Time };
